(function () {
    'use strict';

    function optionConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/optionConfiguration.html',
            link: function (scope) {
            }
        };
    }

    optionConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('optionConfiguration', optionConfiguration);
})();

